"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.applyTemplateToWorkbook = exports.TemplateType = exports.getVariables = void 0;
var generateVariables_1 = require("./generateVariables");
Object.defineProperty(exports, "getVariables", { enumerable: true, get: function () { return generateVariables_1.getVariables; } });
Object.defineProperty(exports, "TemplateType", { enumerable: true, get: function () { return generateVariables_1.TemplateType; } });
var templateEngine_1 = require("./templateEngine");
Object.defineProperty(exports, "applyTemplateToWorkbook", { enumerable: true, get: function () { return templateEngine_1.applyTemplateToWorkbook; } });
//# sourceMappingURL=index.js.map